<template>
	<div v-loading="loading" v-if="hidePage">
		<div class="searcBtn">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="全部" name="all"> </el-tab-pane>
				<el-tab-pane lazy label="正常" name="normal"> </el-tab-pane>
				<el-tab-pane label="超限" name="overrun"> </el-tab-pane>
				<el-tab-pane label="离线" name="leaveLine"></el-tab-pane>
			</el-tabs>
			<div>
				<el-button type="primary" style="height:40px" @click="closeFicker">{{ closeFickerFlag ? "关闭闪动" : "开启闪动" }}</el-button>
				<el-button style="height: 40px;" type="primary" @click="showDia = true">查看详情</el-button>
			</div>
		</div>
		<div v-if="listLength == 0 && listQingniaoLength == 0" style="width:100%;height:100%;">
			<empty :message="'暂无数据'" :height="300"></empty>
		</div>
		<!-- <div v-show="listLength==0" style="width:100%;height:100%;">暂无数据</div> -->

		<el-dialog title="历史记录查询" :visible.sync="showDia" :close-on-click-modal="false" width="70%">
			<div class="content">
				<el-form ref="form" :model="query" label-width="80px">
					<el-form-item label="设备编号">
						<el-select v-model="query.deviceNo" placeholder="选择设备编号" @change="query.pageNum = 0">
							<el-option :value="item.address" v-for="(item, index) in [...list, ...qingniaoList]" :key="index"></el-option>
						</el-select>
					</el-form-item>
					<div class="midden" style="display: flex">
						<el-form-item label="开始时间:" style="width: 100%" class="flex1">
							<el-date-picker v-model="form.startTime" type="datetime" placeholder="选择开始日期时间" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'00:00:00'">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="结束时间:" style="width: 100%" class="flex1">
							<el-date-picker v-model="form.endTime" type="datetime" placeholder="选择结束日期时间" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'23:59:59'"> </el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="viewNow">查询</el-button>
							<el-button type="primary" @click="Reset">重置</el-button>
						</el-form-item>
					</div>

					<div class="botoom">
						<el-table :data="searchList" style="width: 100%" border height="500">
							<el-table-column type="index" label="编号" header-align="center" align="center" fixed width="80"></el-table-column>
							<el-table-column prop="nowtime" label="报警时间" header-align="center" align="center">
								<template slot-scope="scope">
									<p>
										{{ scope.row.nowtime == null ? "暂无数据" : scope.row.nowtime }}
									</p>
								</template>
							</el-table-column>
							<el-table-column prop="evenClass" label="报警类型" header-align="center" align="center">
								<template slot-scope="scope">
									<p>
										{{ scope.row.evenClass == null ? "暂无数据" : scope.row.evenClass }}
									</p>
								</template>
							</el-table-column>
							<el-table-column prop="phone" label="联系电话" header-align="center" align="center" width="120px">
								<template slot-scope="scope">
									<p>
										{{ scope.row.phone == "" ? "暂无数据" : scope.row.phone }}
									</p>
								</template>
							</el-table-column>
							<el-table-column prop="deviceType" label="设备类型" header-align="center" align="center">
								<template slot-scope="scope">
									<p>
										{{ scope.row.deviceType == null ? "暂无数据" : scope.row.deviceType }}
									</p>
								</template>
							</el-table-column>
							<el-table-column prop="detailAddr" label="报警节点" header-align="center" align="center">
								<template slot-scope="scope">
									<p>
										{{ scope.row.detailAddr == null ? "暂无数据" : scope.row.detailAddr }}
									</p>
								</template>
							</el-table-column>
							<el-table-column prop="msgDescribe" label="报警地点" header-align="center" align="center">
								<template slot-scope="scope">
									<p>
										{{ scope.row.msgDescribe == null ? "暂无数据" : scope.row.msgDescribe }}
									</p>
								</template>
							</el-table-column>
						</el-table>

						<el-pagination
							background
							layout="prev, pager, next,sizes,total"
							:current-page.sync="query.pageNum"
							@size-change="getSearchList"
							@current-change="getSearchList"
							:page-sizes="[5, 10, 20, 30]"
							:page-size.sync="query.pageSize"
							:total="total"
						>
						</el-pagination>
					</div>
				</el-form>
			</div>
		</el-dialog>
		<div :class="activeName == 'all' ? 'f-list flex1 flex contrl' : 'f-list flex1 flex contrl1'" id="box">
			<!-- <div class="down"> -->
			<!-- D:\同人建筑防火\wulian_vue\src\assets\img\down.png -->
			<!-- <img src="@/assets/img/down.png" alt="" /> -->
			<!-- </div> -->
			<div
				:class="['pic mt10 ml20', params.address === item.address ? 'picact' : '', item.overrun == 1 ? (closeFickerFlag ? 'firewaring' : '') : '']"
				v-for="(item, index) of list"
				:key="index"
				@click="show(item)"
			>
				<h2 class="center" style="">{{ item.name }}</h2>
				<div class="flex1 flex">
					<div :id="`tab${index}`" class="charts"></div>
					<div :id="`main${index}`" class="charts mt10" style=""></div>
				</div>
				<div class="flex" style="padding: 0px 10px 20px">
					<!-- <table class="hj-message-table" style="margin-bottom:20px" >
          <thead>
            <tr>
              <th style="color:#419AFF">电压</th>
              <th style="color:#E9AA00">电流</th>
              <th style="color:#FF5851" >温度</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ite,idx) of item.eles" :key="idx">
              <td style="color:#419AFF">{{ite.UA}}</td>
              <td style="color:#E9AA00">{{ite.UB}}</td>
              <td style="color:#FF5851">{{ite.UC}}</td>
            </tr>
          </tbody>
        </table> -->
					<ul style="color: #419aff">
						<li class="lith">电压</li>
						<li class="mt5" v-for="(ite, idx) of item.eles" :key="idx">
							{{ ite.UA }}
						</li>
						<li class="mt5">/</li>
					</ul>
					<ul style="color: #e9aa00">
						<li class="lith">电流</li>
						<li class="mt5" v-for="(ite, idx) of item.eles" :key="idx">
							{{ ite.UB }}
						</li>
						<li class="mt5">/</li>
					</ul>
					<ul style="color: #ff5851">
						<li class="lith">温度</li>

						<li class="mt5" v-for="(ite, idx) of item.eles" :key="idx">
							{{ ite.UC }}
						</li>
						<li class="mt5" v-for="(ite, idx) of item.eles" v-if="idx == 2">
							{{ ite.UD }}
						</li>
					</ul>
				</div>
			</div>
			<div :class="['pic1 mt10 ml20', params.address === item.address ? 'picact' : '']" v-for="(item, index) of qingniaoList" :key="index" @click="show(item)">
				<h2 class="center" style="">{{ item.name }}</h2>
				<div class="flex1 flex">
					<div :id="`qingniaoTab${index}`" class="charts flex1"></div>
					<!-- <div :id="`main${index}`" class="charts mt10" style=""></div> -->
				</div>
				<div class="flex" style="padding: 0px 10px 20px"></div>
			</div>
		</div>
		<div style="height: 300px" v-if="list.length || qingniaoList.length">
			<div class="mt20" v-if="'all' == activeName">
				<el-radio-group v-model="radio1" size="mini" @change="handle">
					<el-radio-button :label="item" v-for="item of radioList" :key="item"></el-radio-button>
				</el-radio-group>
			</div>
			<div id="line1" v-if="'all' == activeName"></div>
		</div>
	</div>
</template>
<script>
	import echarts from "echarts";
	import empty from "../../components/empty.vue";

	import { getelectro, electriList } from "../../api/facility";
	export default {
		data() {
			return {
				activeName: "all",
				list: [],
				showDia: false,
				qingniaoList: [],
				radio1: "电压",
				params: {
					c_company_num: "",
					address: "",
					type: "电压",
				},
				nowName: "",
				loading: false,
				radioList: ["电压", "电流", "温度", "漏电"],
				defaultRadioList: ["电压", "电流", "温度", "漏电"],
				searchList: [],
				form: {
					startTime: "",
					endTime: "",
				},
				searchQuery: {
					searchNum: 1,
					searchSize: 10,
				},
				searchTotal: 0,
				query: {
					pageNum: 1,
					pageSize: 10,
					deviceNo: null,
					// companyNum: null,
				},
				total: 0,
				maxiTemperature: 0,
				temperatureOrElectricity: null,
				listLength: null,
				listQingniaoLength: null,
				closeFickerFlag: true,
				hidePage: false,
			};
		},
		components: {
			empty,
		},
		created() {},
		props: ["cpNum"],
		mounted() {
			if (this.cpNum) {
				this.getList();
			}
			// this.activeName='all'
			// this.handleClick()
			// this.getSearchList();
			window.onscroll = function() {
				//为了保证兼容性，这里取两个值，哪个有值取哪一个
				//scrollTop就是触发滚轮事件时滚轮的高度
			};
		},
		watch: {
			cpNum() {
				this.nowName = "";
				this.activeName = "all";
				this.getList();
				this.query.pageNum = 1;
				this.searchList = [];
				this.qingniaoList = [];
				this.list = [];
				// this.getSearchList();
			},
		},
		methods: {
			// 关闭闪动
			closeFicker() {
				this.closeFickerFlag = !this.closeFickerFlag;
			},
			handleClick(tab, event) {
				this.$nextTick(() => {
					this.getList();
				});
			},
			viewNow() {
				var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "f22d1d6348b645e2b29fc08ab5a677f2" : this.cpNum;
				electriList({
					companyNum: cNum,
					...Object.assign(this.query, this.form),
				}).then((res) => {
					console.log(res);
					this.searchList = res.data.data;
					this.total = res.data.total;
					this.query.pageNum = 1;
					this.getSearchList();
				});
			},
			Reset() {
				this.form.startTime = "";
				this.form.endTime = "";
			},
			getSearchList() {
				var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "f22d1d6348b645e2b29fc08ab5a677f2" : this.cpNum;
				electriList({ companyNum: cNum, ...this.query }).then((res) => {
					this.searchList = res.data.data;
					this.total = res.data.total;
				});
			},

			handle(val) {
				this.radio1 = val;
				echarts.init(document.getElementById("line1")).clear();
				this.show();
			},

			changeUnit(evenClass) {
				if (evenClass.indexOf("温度") > -1) {
					evenClass = evenClass + "(℃)";
				} else if (evenClass.indexOf("漏电") > -1) {
					evenClass = "剩余电流" + "(mA)";
				} else if (evenClass.indexOf("电流") > -1) {
					evenClass = evenClass + "(A)";
				} else if (evenClass.indexOf("电压") > -1) {
					evenClass = evenClass + "(V)";
				} else if (evenClass.indexOf("水位") > -1) {
					evenClass = evenClass + "(M)";
				} else if (evenClass.indexOf("水压") > -1) {
					evenClass = evenClass + "(Mpa)";
				}

				return evenClass;
			},
			show(it) {
				log(it, "it");
				//  if (this.activeName=='normal'||'overrun') {
				//     return
				//   }
				if (it?.isQingniao) {
					this.radio1 = "漏电";
					this.radioList = ["漏电"];
				} else {
					this.radioList = { ...this.defaultRadioList };
				}
				if (it) {
					var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "f22d1d6348b645e2b29fc08ab5a677f2" : this.cpNum;

					this.params.c_company_num = cNum;
					this.params.address = it.address;
					this.nowName = it.name;
				}
				this.params.type = this.radio1;

				this.$post("/demarcate/linecharts", this.params).then((res) => {
					var data = res.data;
					console.log(res);
					var arrA = [];
					var arrB = [];
					var arrC = [];
					var arrD = [];
					var arrE = [];
					this.temperatureOrElectricity = res.msg;
					data.map((item, index) => {
						item.nowtime = item.nowtime.split(" ")[1];
						var evenClass = item.evenClass;
						// 判断单位

						evenClass = this.changeUnit(evenClass);

						if (item.evenClass.indexOf("A") !== -1) {
							arrA.push({
								value: item.value,
								name: evenClass,
								time: item.nowtime,
							});
						} else if (item.evenClass.indexOf("B") !== -1) {
							arrB.push({
								value: item.value,
								name: evenClass,
								time: item.nowtime,
							});
						} else if (item.evenClass.indexOf("C") !== -1) {
							arrC.push({
								value: item.value,
								name: evenClass,
								time: item.nowtime,
							});
						} else if (item.evenClass.indexOf("D") !== -1) {
							arrD.push({
								value: item.value,
								name: evenClass,
								time: item.nowtime,
							});
						} else if (item.evenClass.indexOf("漏电") > -1) {
							arrE.push({
								value: item.value,
								name: evenClass,
								time: item.nowtime,
							});
						}
					});
					// return
					this.makeLine(arrA, arrB, arrC, arrD, arrE, it);
				});
			},
			getList() {
				this.loading = true;
				var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "f22d1d6348b645e2b29fc08ab5a677f2" : this.cpNum;
				getelectro({ c_company_num: cNum, ...Object.assign(this.query) }).then((res) => {
					this.list = res.data;
					this.loading = false;
					if (res.ele.length) {
						this.hidePage = true;
						this.query.deviceNo = res.ele[0]?.address;
						this.query.companyNum = res.ele[0]?.c_company_num;
						this.getSearchList();
					} else if (res.qingniao.length) {
						this.hidePage = true;
						this.query.deviceNo = res.qingniao[0]?.address;
						this.query.companyNum = res.qingniao[0]?.c_company_num;
					}

					if (!res.ele.length && !res.qingniao.length) {
						this.list = [];
						this.qingniaoList = [];
						this.hidePage = false;
						this.$message.warning("该业务尚未开通，请联系管理员");
						return;
					}

					var arr = res.ele;
					var newArr = [];
					var valueArr = [];

					arr.map((item, index) => {
						var itArr = item.value.split(":");
						var uniArr = item.unit.split(":");
						var itArr2 = [];
						itArr.map((it, id) => {
							itArr2.push(Number(it).toFixed(2));
						});
						// itArr2=itArr.splice(6,4)
						// itArr2.sort(function(a,b){return b-a})
						// console.log(itArr2,'itArr2');
						var obj = {
							name: item.name,
							address: item.address,
							overrun: item.overrun,
							eles:
								itArr.length > 1
									? [
											{
												UA: `${itArr2[0]} ${uniArr[0]} `,
												UB: `${itArr2[3]} ${uniArr[3]} `,
												UC: `${itArr2[6]} ${uniArr[6]}`,
											},
											{
												UA: `${itArr2[1]} ${uniArr[1]}`,
												UB: `${itArr2[4]} ${uniArr[4]}`,
												UC: `${itArr2[7]} ${uniArr[7]}`,
											},
											{
												UA: `${itArr2[2]} ${uniArr[2]}`,
												UB: `${itArr2[5]} ${uniArr[5]} `,
												UC: `${itArr2[8]} ${uniArr[8]}`,
												UD: `${itArr2[9]} ℃`,
											},
									  ]
									: [
											{ UA: `/ `, UB: `/`, UC: `/`, UD: `/` },
											{ UA: `/`, UB: `/`, UC: `/`, UD: `/` },
											{ UA: `/`, UB: `/`, UC: `/`, UD: `/` },
									  ],
							loudian: itArr2[10] ? itArr2[10] : 0,
							wen: item.maxiTemperature,
						};
						valueArr.push(obj);
					});
					if (this.activeName == "all") {
						this.list = valueArr;
					} else if (this.activeName == "normal") {
						let valueArrnormal = valueArr.map((item, index) => {
							if (item.overrun == 0) {
								return item;
							}
						});
						valueArrnormal = valueArrnormal.filter((item) => item != undefined);
						console.log(valueArrnormal, 333333);

						this.list = valueArrnormal;
					} else if (this.activeName == "overrun") {
						let valueArrnormal = valueArr.map((item, index) => {
							if (item.overrun == 1) {
								return item;
							}
						});
						valueArrnormal = valueArrnormal.filter((item) => item != undefined);
						this.list = valueArrnormal;
					} else if (this.activeName == "leaveLine") {
						let valueArrnormal = valueArr.map((item, index) => {
							if (item.overrun == 2) {
								return item;
							}
						});
						valueArrnormal = valueArrnormal.filter((item) => item != undefined);
						this.list = valueArrnormal;
					}

					// console.log(valueArr,33333);

					// this.query.deviceNo =valueArr[0].address
					this.listLength = this.list.length;
					console.log(this.list, 111111111111111111);

					this.$nextTick(() => {
						if (this.list.length) {
							for (var i = 0; i < this.list.length; i++) {
								this.makeChart(`tab${i}`, this.list[i].loudian);
								this.makeTp(`main${i}`, this.list[i].wen);
							}
						}
					});

					let qingniaoArr = [];

					qingniaoArr = res.qingniao.map((item, index) => {
						return {
							name: item.name,
							address: item.address,
							overrun: item.overrun,
							loudian: item.value ? item.value : 0,
							isQingniao: true,
						};
					});
					if (this.activeName == "all") {
						this.qingniaoList = qingniaoArr;
					} else if (this.activeName == "normal") {
						let qingniaoArrnormal = qingniaoArr.map((item, index) => {
							if (item.overrun == 0) {
								return item;
							}
						});
						qingniaoArrnormal = qingniaoArrnormal.filter((item) => item != undefined);
						console.log(qingniaoArrnormal, 333333);

						this.qingniaoList = qingniaoArrnormal;
					} else if (this.activeName == "overrun") {
						let qingniaoArrnormal = qingniaoArr.map((item, index) => {
							if (item.overrun == 1) {
								return item;
							}
						});
						qingniaoArrnormal = qingniaoArrnormal.filter((item) => item != undefined);
						this.qingniaoList = qingniaoArrnormal;
					} else if (this.activeName == "leaveLine") {
						let qingniaoArrnormal = qingniaoArr.map((item, index) => {
							if (item.overrun == 2) {
								return item;
							}
						});
						qingniaoArrnormal = qingniaoArrnormal.filter((item) => item != undefined);
						this.qingniaoList = qingniaoArrnormal;
					}

					// log(qingniaoArr, 123123123123);
					this.listQingniaoLength = this.qingniaoList.length;
					log(this.listQingniaoLength, 123123123123);
					this.$nextTick(() => {
						if (this.qingniaoList.length) {
							for (var i = 0; i < this.qingniaoList.length; i++) {
								this.makeChart(`qingniaoTab${i}`, this.qingniaoList[i].loudian);
							}
						}
					});

					setTimeout(() => {
						if (this.list[0]) this.show(this.list[0]);
						else {
							this.show(this.qingniaoList[0]);
						}
					}, 100);
				});
			},

			makeChart(id, data) {
				var highlight = "#03b7c9";
				var { dianya, dianliu, yinshu, gonglv, dianneng, dianwang } = this;
				var demoData = [
					{
						name: "剩余电流",
						value: data,
						unit: "mA",
						pos: ["18.6%", "25%"],
						range: [0, 800],
					},
				];
				// console.log(demoData.length)

				let option = {
					backgroundColor: "#efffff",
					grid: {
						width: "100%",
					},
					series: (function() {
						var result = [];
						demoData.forEach(function(item) {
							result.push(
								// 外围刻度
								{
									type: "gauge",
									// center: item.pos,
									radius: "58%", // 1行3个
									splitNumber: item.splitNum || 10,
									min: item.range[0],
									max: item.range[1],
									startAngle: 225,
									endAngle: -45,
									axisLine: {
										show: true,
										lineStyle: {
											width: 2,
											shadowBlur: 0,
											color: [[1, highlight]],
										},
									},
									axisTick: {
										show: true,
										lineStyle: {
											color: highlight,
											width: 1,
										},
										length: -5,
										splitNumber: 10,
									},
									splitLine: {
										show: true,
										length: -10,
										lineStyle: {
											color: highlight,
										},
									},
									axisLabel: {
										distance: -20,
										textStyle: {
											color: highlight,
											fontSize: "10",
											fontWeight: "bold",
										},
									},
									pointer: {
										show: 0,
									},
									detail: {
										show: 0,
									},
								},

								// 内侧指针、数值显示
								{
									name: item.name,
									type: "gauge",
									// center: item.pos,
									radius: "90%",
									startAngle: 225,
									endAngle: -45,
									min: item.range[0],
									max: item.range[1],
									axisLine: {
										show: true,
										lineStyle: {
											width: 16,
											color: [[1, "rgba(255,255,255,.1)"]],
										},
									},
									axisTick: {
										show: 0,
									},
									splitLine: {
										show: 0,
									},
									axisLabel: {
										show: 0,
									},
									pointer: {
										show: true,
										length: "60%",
									},
									detail: {
										show: true,
										offsetCenter: [0, "95%"],
										textStyle: {
											fontSize: 14,
											color: "#666",
										},
										formatter: ["{value} " + (item.unit || ""), "{name|" + item.name + "}"].join("\n"),
										rich: {
											name: {
												fontSize: 13,
												lineHeight: 30,
												color: "#333",
											},
										},
									},
									itemStyle: {
										normal: {
											color: highlight,
										},
									},
									data: [
										{
											value: item.value,
										},
									],
								},
							);
						});

						return result;
					})(),
				};

				echarts.init(document.getElementById(id)).setOption(option);
				this.loading = false;
			},
			makeTp(id, data) {
				data = Number(data);
				// 基于准备好的dom，初始化echarts实例
				var myChart = echarts.init(document.getElementById(id));
				var TP_value = data;
				var kd = [];
				var Gradient = [];
				var leftColor = "";
				var showValue = "";
				// var boxPosition = [0, 0];
				var TP_txt = "";
				// 刻度使用柱状图模拟，短设置1，长的设置3；构造一个数据

				Gradient.push(
					{
						offset: 0,
						color: "#F9504A",
					},
					{
						offset: 0.5,
						color: "#F9504A",
					},
					{
						offset: 1,
						color: "#F9504A",
					},
				);

				if (TP_value > 50) {
					showValue = 50;
				} else {
					if (TP_value <= 0) {
						showValue = 0;
					} else {
						showValue = TP_value + 10;
					}
				}

				// 因为柱状初始化为0，温度存在负值，所以加上负值60和空出距离10
				var option = {
					grid: {
						x: 100, //左侧与y轴的距离
						y: -60, //top部与x轴的距离
						x2: 5, //右侧与y轴的距离
						y2: 80, //bottom部与x轴的距离
					},
					backgroundColor: "#EFFFFF",
					title: {
						text: `${data}℃`,
						show: true,
						color: "#fff",
						textStyle: {
							color: "#000",
							fontSize: 14,
						},
					},
					yAxis: [
						{
							show: false,
							data: [80],
							min: 0,
							max: 120,
							axisLine: {
								show: false,
							},
						},
						{
							show: false,
							min: 0,
							max: 60,
						},
					],
					xAxis: [
						{
							show: false,
							min: -10,
							max: 80,
							data: [],
						},
						{
							show: false,
							min: -10,
							max: 80,
							data: [],
						},
						{
							show: false,
							min: -10,
							max: 80,
							data: [],
						},
						{
							show: false,
							min: -5,
							max: 80,
						},
					],
					series: [
						{
							name: "条",
							type: "bar",
							// 对应上面XAxis的第一个对象配置
							xAxisIndex: 0,
							data: [
								{
									value: showValue,
								},
							],
							barWidth: 8,
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, Gradient),
								},
							},
							z: 2,
						},
						{
							name: "白框",
							type: "bar",
							xAxisIndex: 1,
							barGap: "-100%",
							data: [60],
							barWidth: 12,
							itemStyle: {
								normal: {
									color: "#0C2E6D",
									barBorderRadius: 50,
								},
							},
							z: 1,
						},
						{
							name: "外框",
							type: "bar",
							xAxisIndex: 2,
							barGap: "-100%",
							data: [60],
							// barWidth: 24,
							itemStyle: {
								normal: {
									color: "#F9504A",
									barBorderRadius: 50,
								},
							},
							z: 0,
						},
						{
							name: "圆",
							type: "scatter",
							hoverAnimation: false,
							data: [0],
							xAxisIndex: 0,
							symbolSize: 20,
							itemStyle: {
								normal: {
									color: "#F9504A",
									opacity: 1,
								},
							},
							z: 2,
						},
						{
							name: "白圆",
							type: "scatter",
							hoverAnimation: false,
							data: [0],
							xAxisIndex: 1,
							symbolSize: 24,
							itemStyle: {
								normal: {
									color: "#0C2E6D",
									opacity: 1,
								},
							},
							z: 1,
						},
						// {
						//   name: '外圆',
						//   type: 'scatter',
						//   hoverAnimation: false,
						//   data: [0],
						//   // xAxisIndex: 2,
						//   // symbolSize: 30,
						//   itemStyle: {
						//     normal: {
						//       color: '#F9504A',
						//       opacity: 1,
						//     },
						//   },
						//   z: 0,
						// },
					],
				};

				myChart.setOption(option);
			},

			makeLine(arr1, arr2, arr3, arr4, arr5) {
				if (arr5.length) {
					var arrL = [];
					var arr = [];
					var timmer = [];

					arr5.map((item) => {
						timmer.push(item.time);
						arrL.push(item.value);
					});
					arr.push({
						name: arr5[0].name,
						data: arrL,
						type: "line",
					});
				} else if (arr1 || arr2 || arr3 || arr4) {
					var timmer = [];
					var arrA = [];
					var arrB = [];
					var arrC = [];
					var arrD = [];
					var arr = [];

					if (arr1.length) {
						arr1.map((item) => {
							timmer.push(item.time);
							arrA.push(item.value);
						});
						arr.push({
							name: arr1[0].name,
							data: arrA,
							type: "line",
							stack: "总量",
						});
					}
					if (arr2.length) {
						arr2.map((item) => {
							arrB.push(item.value);
						});
						arr.push({ name: arr2[0].name, data: arrB, type: "line" });
					}
					if (arr3.length) {
						arr3.map((item) => {
							arrC.push(item.value);
						});
						arr.push({ name: arr3[0].name, data: arrC, type: "line" });
					}
					if (arr4.length) {
						arr4.map((item) => {
							arrD.push(item.value);
						});
						arr.push({ name: arr4[0].name, data: arrD, type: "line" });
					}
				}
				arr.push({
					type: "line", // 折线图
					markLine: {
						// label: {
						//   show: false,
						// },
						// silent: true, // 不触发鼠标事件
						// lineStyle: {
						//   // 标线样式
						//   color: "FF1D00",
						//   type: "solid",
						// },
						data: [
							{
								// 标线数据
								name: "超限值",

								yAxis: [Number(this.temperatureOrElectricity)],
								lineStyle: { color: "#FF1D00" }, // y 轴
							},
						],
					},
				});
				console.log(arr, "arr");

				let option = {
					title: [
						{
							// left: 'center',
							text: this.nowName,
						},
						{
							right: "10",
							text: Number(this.temperatureOrElectricity) ? `超限值:${Number(this.temperatureOrElectricity)}` : "",
							textStyle: {
								lineHeight: "15",
								fontSize: "15",
							},
						},
					],
					// {
					//   text: this.nowName,
					//   subtext:Number(this.temperatureOrElectricity),
					//   subtextStyle:{
					//     align:'right'
					//   }
					// },
					tooltip: {
						trigger: "axis",
						axisPointer: {
							lineStyle: {
								color: "#999",
							},
						},
					},
					legend: {
						show: arr.length,
					},

					grid: {
						left: "3%",
						right: "4%",
						bottom: "1%",
						top: "24%",
						containLabel: true,
					},
					xAxis: [
						{
							type: "category",
							boundaryGap: false,
							axisLabel: {
								interval: 0,
							},
							axisLine: {
								lineStyle: {
									color: "#999",
								},
							},
							data: timmer,
						},
					],
					yAxis: [
						{
							name: this.changeUnit(this.params.type),
							type: "value",

							axisTick: {
								show: false,
							},
							axisLine: {
								lineStyle: {
									color: "#999",
								},
							},
							axisLabel: {
								margin: 30,
								textStyle: {
									fontSize: 14,
								},
							},
							splitLine: {
								lineStyle: {
									color: "#eee",
								},
							},
						},
					],
					dataZoom: [
						{
							start: 0,
							type: "inside",
						},
						{
							type: "slider",
							start: 0,
						},
					],
					series: arr,
				};

				echarts.init(document.getElementById("line1")).setOption(option);
			},
		},
	};
</script>
<style scoped lang="scss">
	.searcBtn {
		display: flex;
		justify-content: space-between;
	}
	.contrl {
		max-height: 19.5vw;
		overflow: auto;
		ul {
			box-sizing: border-box;
			flex: 1;
			height: 100%;
			margin-left: 2px;

			&:nth-child(3) {
				overflow: auto;
			}
			li {
				width: auto;
				height: auto;
				text-align: center;
				margin-right: 0px;
				margin-bottom: 0px;
				// border-top: 1px solid groove !important;
			}
		}
		.down {
			width: 80px;
			height: 80px;
			position: absolute;
			right: 224px;
			top: 300px;
			img {
				width: 80px;
				height: 80px;
			}
		}
	}
	.contrl1 {
		overflow: auto;
		ul {
			box-sizing: border-box;
			flex: 1;
			height: 100%;
			margin-left: 2px;

			li {
				width: auto;
				height: auto;
				text-align: center;
				margin-right: 0px;
				margin-bottom: 0px;
				// border-top: 1px solid groove !important;
			}
		}
	}
	.mt5 {
		margin-top: 5px;
	}
	.lith {
		font-weight: 900;
	}
	.charts {
		height: 200px;
		width: 200px;
		background: #efffff;
		position: relative;
	}
	.pic {
		background: #efffff;
		width: 300px;
		height: 400px;
		border: 2px solid #eaeaea;
	}
	.pic1 {
		background: #efffff;
		width: 300px;
		height: 260px;
		border: 2px solid #eaeaea;
	}
	.picact {
		border: 2px solid blueviolet;
	}

	#line1 {
		height: 16.5vw;
		width: 100%;
	}
	.speed {
		width: 30px;
		height: 30px;
		margin-left: 10px;
	}
	.wind_speedNull {
		width: 30px;
		height: 30px;
		margin-left: 10px;
	}
	.wind_speed {
		width: 30px;
		height: 30px;
		margin-left: 10px;
	}
	.content {
		width: 100%;
		height: 100%;
	}
	.firewaring {
		// div {
		border-radius: 0 !important;
		animation: warningmove 0.3s infinite;
		animation-direction: alternate;
		// }
		// animation: warningmove 0.3s infinite;
	}
	@keyframes warningmove {
		from {
			// border: 2px solid #ed1c24
			box-shadow: 3px 3px 10px #ed1c24, -3px -3px 10px #ed1c24;
			// background: #ed1c24;
		}
		to {
			// border: 2px solid #ffb800

			box-shadow: 3px 3px 10px #ffb800, -3px -3px 10px #ffb800;

			// background: #ffb800;
		}
	}
</style>
